var  ConfigUrl = {
    configUrl:"https://weixin.loongair.cn/dist/index.html#",//测试
    // configUrl:"",//正式
};
export default  ConfigUrl;


// WEBPACK FOOTER //
// ./src/assets/js/configurl.js